import { useNavigate } from 'react-router';

/**
 * Extract numeric ID from Daylite API self URL
 * Converts paths like "/v1/opportunities/5071" to "5071"
 */
export const extractIdFromSelf = (selfUrl: string): string => {
  // Handle empty or invalid URLs
  if (!selfUrl) return '';
  
  // Use regex to extract the numeric ID from the end of the path
  const matches = selfUrl.match(/\/([^/]+)$/);
  
  // Return the extracted ID or empty string if no match
  return matches && matches[1] ? matches[1] : '';
};

/**
 * Hook that returns a function to navigate to event pages
 * Can be used with either extracted IDs or full self URLs
 */
export const useNavToEvent = () => {
  const navigate = useNavigate();
  
  /**
   * Navigate to an event page
   * @param eventIdOrSelf - Either a direct event ID or a Daylite self URL
   */
  const navToEvent = (eventIdOrSelf: string) => {
    // Check if the parameter is a self URL and extract ID if needed
    const eventId = eventIdOrSelf.includes('/') 
      ? extractIdFromSelf(eventIdOrSelf)
      : eventIdOrSelf;
    
    if (!eventId) {
      console.error('Invalid event ID or self URL:', eventIdOrSelf);
      return;
    }
    
    // Navigate to the talent view of the event page with the ID as a query parameter
    navigate(`/event/talent?id=${eventId}`);
  };
  
  return navToEvent;
};

export default useNavToEvent;
